export const DEFAULT_IMAGE_DIMENSIONS = {
  width: '100%',
  aspectRatio: 4.5,
};

export const FALLBACK_IMAGE_DIMENSIONS = {
  width: '100%',
  aspectRatio: 4.5,
};
